export const PRODUCTS_TOOLTIPS = {
  4: 'Claim every possible deduction with live bank feeds, build in tax tools, logbooks, document storage and live tax reports, including MyTax.',
  5: 'Have a property portfolio? Simply add Property Tank so you can monitor your whole property portfolio in one place',
  6: 'Manage your side hussle like a pro with auto invoicing, live bank feeds, roll fwd losses, BAS and business reporting.',
  7: 'Track your crypto, shares and non listed assets, plus access tax reports all year round.',
  8: 'See where your money goes and how it flows. Set goals, track progress, and take control with Money Tank.',
  all: 'Need it all? Manage your work, property, sole trader and asset holdings seamlessly with All Tanks in one place.'
};

